export const TEMPUS_PRO_PATH = '/form/take-now/assessment';
export { App as TempusPro } from './components/App';
